export default {
  ER_DUP_ENTRY: 'ER_DUP_ENTRY',
  NONEXISTENT_ENTITY: 'NONEXISTENT_ENTITY',
};
